import { useSelector } from "react-redux";
import { Accordion } from "@asosteam/asos-web-component-library-accordion";
import { getCategoryFaqs } from "../../state/modules/category";
import { withTranslation } from "../translation";
import PropTypes from "prop-types";
import styles from "./styles.css";
import { parseTextWithLinksAndFormatting } from "./parseTextWithLinksAndFormatting";
import { isFacetedNavPage } from "../../state/modules/category/selectors";
import { hasActiveFacetFilters } from "../../state/modules/search";

const CategoryFaqs = ({ formatTranslation }) => {
  const isFaceted = useSelector(isFacetedNavPage);
  const faqs = useSelector(getCategoryFaqs);
  const hasActiveFilters = useSelector(hasActiveFacetFilters);

  if (isFaceted) return null;

  const shouldHideFaqs = hasActiveFilters || !faqs?.length;
  if (shouldHideFaqs) return null;

  return (
    <>
      <div className={styles.faqsContainer}>
        <h2 className={styles.title}>
          {formatTranslation("plp_web_faq_title")}
        </h2>
        <Accordion
          classname={styles.accordion}
          headingSizing="london2"
          items={faqs.map((faq) => ({
            title: faq.title,
            content: parseTextWithLinksAndFormatting(faq.content, faq.links),
            contentId: faq.contentId,
          }))}
        />
      </div>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faqs.map((faq) => ({
              "@type": "Question",
              name: faq.title,
              acceptedAnswer: {
                "@type": "Answer",
                text: parseTextWithLinksAndFormatting(
                  faq.content,
                  faq.links,
                  true,
                ),
              },
            })),
          }),
        }}
      />
    </>
  );
};

CategoryFaqs.propTypes = {
  formatTranslation: PropTypes.func.isRequired,
};

export default withTranslation(CategoryFaqs);
